import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { PaymentV2Service, StorageService, UtilService } from '../../shared/services';
import { IPaymentSipConfig } from '../payment-sip/payment-sip.model';

@Component({
  selector: 'app-payment-pre-used',
  templateUrl: './payment-pre-used.component.html',
  styleUrls: ['./payment-pre-used.component.scss']
})
export class PaymentPreUsedComponent implements OnInit, OnChanges {

  @Input() config: IPaymentSipConfig;
  @Output() dataEmit = new EventEmitter();
  selectedOp;
  selectedRadio;
  oneTapOtpPopup;
  isMobile;

  constructor(
    public paymentV2: PaymentV2Service,
    public util: UtilService,
    private storage: StorageService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.config?.currentValue?.paymentOptions?.options?.PREVIOUSPAYMENTGATEWAY && !this.selectedRadio) {
      this.selectedRadio = Object.keys(this.config.paymentOptions.options.PREVIOUSPAYMENTGATEWAY).sort()[0];
      this.selectedOp = { value: this.config.paymentOptions.options.PREVIOUSPAYMENTGATEWAY[this.selectedRadio] };
    }
  }

  ngOnInit(): void {
    this.isMobile = this.util?.isMobile();
    this.paymentV2.pledgeBtn.subscribe(tab => {
      if (tab === 'pu' && this.selectedOp) {
        this.submit(this.selectedOp);
      }
    });
  }

  /** OTP varification for one tap payment */
  otpVerified = (isVarified) => {
    this.oneTapOtpPopup = isVarified;
    if (isVarified) {
      this.paymentV2.otpVerified = isVarified;
      this.submit(this.selectedOp);
    }
  }

  submit(data) {
    let payload: any = {
      mode: data.value.payment_mode,
      mode_value: data.value.payment_mode_value,
    };

    if (data.value.payment_mode_value === 'VPA') {
      payload.VPA = data.value.checksum;
      payload.origin_vpa = 'payment_form';
    }

    const isLoggedIn = this.storage.get('user').user.isLoggedIn;
    if (data.value.checksum && data.value.payment_gateway.match('stripe') && !this.oneTapOtpPopup && !isLoggedIn) {
      this.oneTapOtpPopup = true;
      return;
    }
    if (data.value.payment_mode === 'CARD' && data.value.checksum) {
      payload = Object.assign(payload, {
        card_name_fill: this.config.user.full_name,
        customer_id: data.value.checksum.customer_id,
        donor_pincode: this.config.user.pincode
      });
    }
    this.paymentV2.preUsedOptionEvent(this.config.fundraiser, this.config.cart, payload.mode);
    this.dataEmit.emit(payload);
  }
}
